import Constant from '@/const';
import axios from 'axios';

const getProcessedIhsCount = async params => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/ihs/encounter/count'),
      {
        params,
      },
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getProcessedIhsCount;
